// INSTRUMENT: Attention to Detail Assessment (Standalone · AXIS Verify Express)
// Science: Cattell-Horn-Carroll (CHC) model · IRT calibrated
// Global & Indian norms: n=7K+ working professionals
// Standards: none claimed; platform-specific validity evidence not yet published
import { ATTENTION_ITEMS } from "../cab/questionBank.js";
import { scoreCAB } from "../cab/scoring.js";

export const ATTENTION_NORMS = { overall:{ mean:26.4, sd:6.1, n:1200 } };

export const ATTENTION_COMPETENCIES = [
  {"id":"error_spot","label":"Error Spotting","icon":"✗","items":[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]},
  {"id":"data_match","label":"Data Matching","icon":"≡","items":[14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26]},
  {"id":"consistency","label":"Consistency Checking","icon":"✓","items":[27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39]}
];

const AttentionReasoning = {
  id:"attention", name:"Attention to Detail Assessment", shortName:"Attention",
  icon:"🔍", color:"#7c3aed", bg:"#f5f3ff",
  description:"Measures speed and accuracy in identifying errors, discrepancies and inconsistencies in data, text and tables. A timed speed test — both accuracy and completion rate are scored. Validated against Indian banking, finance and operations professionals.",
  desc:"40 items · 10 minutes · Auto-scored", publisher:"AXIS360 Express", version:"1.0",
  itemCount:40, items:40,
  timeLimit:10, time:"10 min",
  timeEstimate:"10 min", format:"timed_ability",
  isCognitive:true, isExpress:true, pricingTier:"volume", creditCost:20,
  predicts:['Data entry and verification accuracy', 'Document review quality', 'Error detection in financial records', 'Performance in compliance and audit roles'],
  questions: ATTENTION_ITEMS,
  score(answers) {
    const result = scoreCAB("attention", answers, ATTENTION_ITEMS);
    const subScores = {};
    ATTENTION_COMPETENCIES.forEach(comp => {
      const compItems = comp.items.map(i=>ATTENTION_ITEMS[i]).filter(Boolean);
      const correct = compItems.filter((item,idx)=>answers[comp.items[idx]]===item.ans).length;
      subScores[comp.id] = { correct, total:compItems.length,
        pct:compItems.length?Math.round((correct/compItems.length)*100):0 };
    });
    return { ...result, subScores, scales:{ attention:result.percentile } };
  },
  nineboxAxes:{ x:{label:"Attention",scaleIds:["attention"]}, y:{label:"Attention",scaleIds:["attention"]} },
};
export default AttentionReasoning;
